import React, { useContext, useState } from 'react';
import { client } from 'shared';
import { LocationListLayout, LocationRow } from '../shared';
import { BusinessLocationPreferredWorker } from 'models';
import { PreferredWorkerModalContext } from './PreferredWorkerModalContext';

interface ILocationCheckbox {
    [key: string]: boolean;
}

interface IPreferredWorkerRequest {
    business_id: number;
    preferred_worker_id: number;
    preferred_worker_locations: ILocationParam[];
}

interface ILocationParam {
    business_location_id: string;
    preferred_worker_id: number;
    is_preferred_worker: boolean;
}

export default function LocationsList() {
    const { business, businessLocationId, provider, locations, setLocations, setError, onSuccess, onClose } =
        useContext(PreferredWorkerModalContext);

    function getCheckboxes(checked: boolean = true, useChecked: boolean = true) {
        const checkboxes: ILocationCheckbox = {};
        locations.map(
            (location: BusinessLocationPreferredWorker) =>
                (checkboxes[`${location.id}`] = useChecked ? checked : location.is_preferred_worker),
        );
        return checkboxes;
    }

    function onClick() {
        setSubmitting(true);

        const requestParams: IPreferredWorkerRequest = {
            business_id: business.id,
            preferred_worker_id: provider.id,
            preferred_worker_locations: [],
        };

        requestParams.preferred_worker_locations = Object.entries(locationCheckboxes).map(
            (locationCheckbox: [string, boolean]) => ({
                business_location_id: locationCheckbox[0],
                preferred_worker_id: provider.id,
                is_preferred_worker: locationCheckbox[1],
            }),
        );

        client('api/preferred-worker/update-locations/', {
            method: 'POST',
            body: requestParams,
        })
            .then((response: BusinessLocationPreferredWorker[]) => {
                setLocations(response);
                onClose();
                onSuccess(response);
            })
            .catch(() => setError(true))
            .finally(() => setSubmitting(false));
    }

    const [locationCheckboxes, setLocationCheckboxes] = useState(getCheckboxes(false, false));
    const [submitting, setSubmitting] = useState(false);

    function setCheckbox(checked: boolean, id: string) {
        setLocationCheckboxes({ ...locationCheckboxes, [`${id}`]: checked });
    }

    return (
        <LocationListLayout
            businessName={business.name}
            allLabel="Mark preferred for all locations"
            allChecked={Object.values(locationCheckboxes).every((value) => value)}
            onToggleAll={(checked) => setLocationCheckboxes(getCheckboxes(checked, true))}
            onCancel={onClose}
            onSubmit={onClick}
            submitting={submitting}
        >
            {locations.map((location: BusinessLocationPreferredWorker) => (
                <LocationRow
                    key={location.id}
                    highlight={businessLocationId === location.id}
                    createdBy={location.preferred_worker_created_by}
                    name={location.name}
                    addressLine={`${location.address.street}, ${location.address.city}, ${location.address.state}`}
                    checked={locationCheckboxes[`${location.id}`]}
                    disabled={submitting}
                    onToggle={(checked) => setCheckbox(checked, location.id.toString())}
                />
            ))}
        </LocationListLayout>
    );
}
